<template>
    <div id="vendor_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vendorHeader" v-if="$route.params.id > 0" >Update Vendor</span>
                    <span class="page-title" id="vendorHeader" v-else>Add Vendor</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath" >
                        <i class="fp-back"> </i>    Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content vendor-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title form-custom-select" id="VendorForm">
                                <!-- <h5 class="color-blue font-bold"> Vendor Details</h5> -->
                                <div class='form-row row-cols-md-6 row-cols-1'>

                                    <div class="form-group custom-checkbox col">
                                        <label for="one_time_vendor" class="checkbox-custom">Is One-Time Vendor?
                                            <input type="checkbox" v-model="oneTimeVendor" id="one_time_vendor" name="one_time_vendor">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>

                                    <div class="form-group custom-checkbox col">
                                        <label for="financierVendor" class="checkbox-custom">Is Financier?
                                            <input type="checkbox" v-model="financierVendor" id="financierVendor" name="financierVendor">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="form-group custom-checkbox col">
                                        <label for="ntlsvendor" class="checkbox-custom">Is NTLS Vendor?
                                            <input type="checkbox" v-model="ntlsvendor" id="ntlsvendor" name="ntlsvendor">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="form-group custom-checkbox col">
                                        <label for="required_attachment" class="checkbox-custom">Vendor Invoice required?
                                            <input type="checkbox" v-model="requiredAttachment" id="required_attachment" name="required_attachment">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="form-group custom-checkbox col">
                                        <label for="required_remittance" class="checkbox-custom">Remittance required?
                                            <input type="checkbox" v-model="requiredRemittance" id="required_remittance" name="required_remittance">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                                <div class='form-row row-cols-md-4 row-cols-1'>
                                    <div class="col form-group">
                                        <template v-if="$route.params.id > 0">
                                            <label class="control-label require" for="code"> Vendor Code:</label>
                                        </template>
                                        <template v-else>
                                            <label class="control-label require" for="code">Temp Code:</label>
                                        </template>
                                        <div class="form-row">
                                            <div class="col">
                                                <input type="text" v-model="codeField1" id="codeField1" name="codeField1" class="form-control" placeholder=""/>
                                                <div class="field-error">{{ vendor_code_error_msg }}</div>
                                            </div>
                                            <div class="col">
                                                <input type="text" v-model="codeField2" id="codeField2" name="codeField2" class="form-control" placeholder=""/>
                                            </div>
                                            <div class="col">
                                                <input type="text" v-model="codeField3" id="codeField3" name="codeField3" class="form-control" placeholder=""/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Vendor Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Vendor Name" name="name">
                                        <div class="field-error">{{ nameerrors }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">DBA Name:</label>
                                        <input type="text" class="form-control" v-model="DBAname" id="dba_name" placeholder="Enter DBA Name" name="dba_name">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Email:</label>
                                        <input type="text" class="form-control" v-model="email" id="email" placeholder="Enter Email" name="email">
                                        <div class="field-error">{{ email_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="phone_number">Phone Number:</label>
                                        <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="phone_number" id="phone_number" placeholder="999-999-9999" name="phone_number">
                                        <!-- <input-mask id="phone_number" :alwaysShowMask="true" name="phone_number" v-model="phone_number" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                        <div class="field-error">{{phone_number_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Is Vendor 1099 Eligible?</label>
                                        <div class="custome-radiobtn">
                                            <div>
                                                <label class="boolean optional radio-custom" for="misc1_eligible"> 1099 Eligible
                                                    <input type="radio" v-model="miscEligible" :value="1" id="misc1_eligible" name="federal_tax_eligible">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div>
                                                <label class="boolean optional radio-custom" for="misc2_eligible"> Not 1099 Eligible
                                                    <input type="radio" v-model="miscEligible" :value="0" id="misc2_eligible" name="federal_tax_eligible">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label :class="'control-label '+ isRequired">Federal Tax Type</label>
                                        <v-select v-show="miscEligible" v-model="eligibleVendorTaxType" name="federalTaxType" placeholder="Select Federal Tax Type."
                                                label="text"
                                                :options="eligibleTaxTypeArr" >
                                        </v-select>
                                        <v-select v-show="!miscEligible" v-model="notEligibleVendorTaxType" name="federalTaxType" placeholder="Select Federal Tax Type."
                                                label="text"
                                                :options="notEligibleTaxTypeArr" >
                                        </v-select>
                                        <div class="field-error">{{ taxerrors }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Federal Employer Identification No:</label>
                                        <input type="text" class="form-control" v-model="FEIN" id="fein" placeholder="Enter FEIN Number" name="fein">
                                        <div class="field-error">{{ feinrrors }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="term_id">Term:</label>
                                        <v-select v-model="term_id" name="term_id" placeholder="Select Term."
                                                label="text"
                                                :options="termArr">
                                        </v-select>
                                        <div class="field-error">{{ termerrors }}</div>
                                    </div>
                                    <div class="col form-group">
                                            <label class="control-label require" for="payment_type">Payment Type:</label>
                                        <v-select v-model="payment_type" name="payment_type" placeholder="Select Payment Type."
                                                label="text"
                                                :options="paymentArr">
                                        </v-select>
                                        <div class="field-error">{{ paymentTypeError }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="website">Website:</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend"><span class="input-group-text">http://</span></div>
                                            <input type="text" class="form-control" v-model="website" id="website" placeholder="Enter Website" name="website" aria-describedby="basic-addon3">
                                        </div>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="vendor_tax_id_number">Vendor Tax ID Number:</label>
                                        <input type="text" class="form-control" v-model="vendor_tax_id_number" id="vendor_tax_id_number" placeholder="Enter Vendor Tax ID Number" name="VendorTaxIDNumber">
                                        <div class="field-error">{{vendorTaxIDNoError}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="vendor_type">Vendor Type:</label>
                                        <input type="text" class="form-control" v-model="vendor_type" id="vendor_type" placeholder="Enter Vendor Type" name="VendorType">
                                        <div class="field-error">{{vendorTypeError}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label">Vendor Added Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="expiry_date" name="vendor_create_date" v-model="vendor_create_date" :config="optionsDate" aria-describedby="basic-addon3"
                                                            class='cal-icon'></date-picker>
                                            <label for="expiry_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{vendorCreateError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="fax">Fax:</label>
                                        <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="fax" id="fax" placeholder="999-999-9999" name="fax">
                                        <!-- <input-mask id="fax" :alwaysShowMask="true" name="fax" v-model="fax" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                        <div class="field-error">{{faxError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="address_1">Address:</label>
                                        <input type="text" class="form-control" v-model="address_1" id="address_1" placeholder="Enter Address" name="address_1">
                                        <div class="field-error">{{ addressErrorMsg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="address_2">Address Line 2:</label>
                                        <input type="text" class="form-control" v-model="address_2" id="address_2" placeholder="Enter Address Line 2" name="address_2">
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="state">State/Province/Region</label>
                                        <v-select v-model="state" name="state"

                                                    label="text" :filterable="false" :options="stateArr"
                                                    @search="onSearchState"
                                                    placeholder="Select State" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search State...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="city_id">City</label>
                                        <a href="javascript:void(0)" v-on:click="addNewCity()" class="pull-right color-blue link-text"> <i class="fp-add font-weight-bold" style="font-size:10px;"></i> Add City</a>
                                        <v-select v-model="city_id" name="city_id"
                                                label="text" :filterable="false" :options="cityArr"
                                                @search="onSearchCity"
                                                placeholder="Select City" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search City...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="error">{{city_error_msg}}</div>
                                        <div class="field-error"></div>
                                    </div>
                                    <template v-if="canAddCity">
                                      <div class="citycreate wo-vendorinv-form" >
                                          <city-add-form :id="'addCity'" v-on:populateCityId="popCityName($event)" class="citycreate wo-vendorinv-panel"></city-add-form>
                                      </div>
                                    </template>
                                    <div class="col form-group">
                                        <label class="control-label" for="zip">Zip/Postal Code:</label>
                                        <input type="text" id="zip" name="zip" class="form-control" v-model="zip" @keypress="isIntegerCheck($event)">
                                        <div class="field-error">{{post_code_error}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="assignee">Assignee:</label>
                                        <v-select v-model="assignee" name="assignee"
                                                    label="text" :filterable="false" :options="vendorArr"
                                                    @search="onSearchAssignee"
                                                    placeholder="Select Assignee" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Assignee...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error"></div>
                                    </div>
                                  <div class="col form-group">
                                    <label :class="'control-label '+ isRequired">Status:</label>
                                    <v-select v-model="vendorStatus" name="status" placeholder="Select Status."
                                              label="text"
                                              :options="statusArr" >
                                    </v-select>
                                    <div class="field-error">{{ taxerrors }}</div>
                                  </div>
                                </div>
                                <div class='form-row row-cols-md-6 row-cols-1'>
                                    <div class="form-group custom-checkbox col">
                                        <label for="poRequired" class="checkbox-custom">PO require
                                            <input type="checkbox" v-model="po_required" id="poRequired" name="poRequired" v-on:click="poRequired($event)">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="form-group custom-checkbox col">
                                        <label for="seperateCheque" class="checkbox-custom">Seperate Cheque
                                            <input type="checkbox" v-model="seperate_cheque" id="seperate_cheque" name="seperate_cheque" v-on:click="seperateCheque($event)">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="form-group custom-checkbox col">
                                        <label for="monthlyPayable" class="checkbox-custom">Monthly Payable
                                            <input type="checkbox" v-model="monthly_payable" id="monthly_payable" name="monthly_payable" v-on:click="monthlyPayable($event)">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1 ach-payment-section">
                                    <div class="col form-group verification-section-main">
                                        <label class="control-label">File:</label>
                                        <div class="custom-upload-container" data-provides="fileupload">
                                            <label for="vendorFiles" class="fileupload-new btn btn-secondary"><i class="fp-upload"></i>Upload</label>
                                            <input class="hide" type="file" id="vendorFiles" ref="files" v-on:change="handleFilesUpload()"/>
                                        </div>
                                    </div>
                                    <div class="field-error">{{fileerror_msg}}</div>
                                    <template v-if="!isUpdate">
                                        <template v-for="(file, key) in filesArr">
                                            <div v-bind:key="key" class="file-container" :id="'fileDiv'+file.id">
                                                <span class="fileupload-preview">{{ file.name }}</span>
                                                <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteDoc(file.id,key)" style="float: right">
                                                    <i class="fp-delete"></i>
                                                </a>
                                            </div>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template  v-for="(files, key1) in existFilesArr">
                                            <div v-bind:key="key1" class="file-container">
                                                <a href="javascript:void(0)" class="fileupload-preview" v-on:click="openDocument(files.url,files.ext)">{{ files.display_name }}</a>
                                                <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteVendorFile(key1,files.path)" style="float: right">
                                                    <i class="fp-delete"></i>
                                                </a>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                                <template v-if="financierVendor">
                                    <div class='form-row row-cols-md-4 row-cols-1'>
                                        <div class="col form-group">
                                            <label class="control-label require" for="state">Financier GL Account:</label>
                                            <v-select v-model="financier_gl" name="financier_gl"

                                                        label="text" :filterable="false" :options="liabilityAccountsArr"
                                                        @search="onSearchFinancierGL"
                                                        placeholder="Select GL Account" class="custom-ci-auto-search" :disabled="disableFinancierGL">
                                                <template slot="no-options">
                                                    Search GL Account...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{ financier_gl_error_msg}}</div>
                                        </div>
                                    </div>
                                </template>
                                <h5 class="color-blue font-bold mt-3"> Contact Details</h5>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="contact_name">Contact Name:</label>
                                        <input type="text" class="form-control" v-model="contact_name" id="contact_name" placeholder="Enter Contact Name" name="contact_name">
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="contact_email">Contact Email:</label>
                                        <input type="text" class="form-control" name="contact_email" v-model="contactEmail" id="contact_email"/>
                                        <div class="field-error">{{contact_email_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="contact_phone_number">Contact Phone:</label>
                                        <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="contact_phone_number" id="contact_phone_number" placeholder="999-999-9999" name="contact_phone_number">
                                        <!-- <input-mask id="contact_phone_number" :alwaysShowMask="true" name="contact_phone_number" v-model="contact_phone_number" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                        <div class="field-error">{{contact_phone_number_error_msg}}</div>
                                    </div>
                                </div>

                                <!-- <h5 class="color-blue font-bold mt-3"> Payment Details</h5>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="payVendorNO">Pay to Vendor No:</label>
                                        <input type="text" class="form-control" v-model="pay_to_vendor_number" id="payVendorNO" placeholder="Enter Vendor Number" name="payVendorNo">
                                        <div class="field-error">{{payToVendorNoError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="payVendor">Pay To Entity Name:</label>
                                        <input type="text" class="form-control" v-model="pay_to_vendor" id="payVendor" placeholder="Enter Entity Name" name="payEntity">
                                        <div class="field-error">{{payToVendorError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Pay To Exists?</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="pay1Exist"> Yes
                                                    <input type="radio" v-model="pay_to_exist" :value="1" id="pay1Exist" name="payExist">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="pay2Exist"> No
                                                    <input type="radio" v-model="pay_to_exist" :value="0" id="pay2Exist" checked name="payExist">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="field-error">{{payExistError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="payVendor">Assignee Number:</label>
                                        <input type="text" class="form-control" v-model="assignee_number" id="assignee_number" placeholder="Enter Assignee Number" name="assigneeNumber">
                                        <div class="field-error">{{assigneeError}}</div>
                                    </div>
                                    <div class="col form-group">
                                            <label class="control-label" for="payVendor">Payment Type:</label>
                                        <v-select v-model="payment_type_id" name="payment_type_id" placeholder="Select Payment Type."
                                                label="text"
                                                :options="paymenttypeArr">
                                        </v-select>
                                        <div class="field-error">{{ paymentTypeError }}</div>
                                    </div>
                                </div> -->
                                <!-- <h5 class="color-blue font-bold mt-3"> Invoice Details</h5>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="totalAmount">Total Invoice Amount:</label>
                                        <input type="text" class="form-control" v-model="total_invoice_amount" id="totalAmount" placeholder="Enter Total Invoice Amount " name="totalInvoiceAmount" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{totalInvoiceAmountError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="totalPayAmount">Total Amount To Pay:</label>
                                        <input type="text" class="form-control" v-model="total_pay_amount" id="totalPayAmount" placeholder="Enter Total Pay Amount " name="totalPayAmount" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{totalPayAmountError}}</div>
                                    </div>
                                    <div class="col form-group cal-personal-detail">
                                        <label class="control-label ">Last Invoice Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="last_invoice_date" name="last_invoice_date" v-model="last_invoice_date" :config="optionsDate" aria-describedby="basic-addon3"
                                                        class='cal-icon'></date-picker>
                                            <label for="last_invoice_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{lastInvoiceDateError}}</div>
                                    </div>
                                </div> -->
                                <!-- <h5 class="color-blue font-bold mt-3">Classification</h5>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <v-select
                                            class="multiselect"
                                            v-model="classification"
                                            :options="classificationArr"
                                            :close-on-select="true"
                                            :show-labels="true"
                                            :multiple="true"
                                            :searchable="true"
                                            track-by="text"
                                            label="text"
                                            placeholder="Please Select Classification"
                                        >
                                        </v-select>
                                    </div>
                                </div> -->
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createVendorBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateVendor" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createVendorBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateVendor" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueVendorBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateVendor(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i> Save and Continue
                                    </button>
                                    <button type="submit" id="cancelVendorBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath" >
                                        <i class="fp-close"> </i> Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>

import Vue from "vue";


import {commonMixins} from '../mixins/commonMixins';
import moment from 'moment';

// import InputMask from 'vue-input-mask';
// Vue.component('input-mask', InputMask);
import CityCreate from '@/components/CityCreate.vue';
Vue.component("city-add-form", CityCreate);

export default {
  name: "VendorCreate",
  metaInfo() {
    return {
        title: (this.$route.params.id > 0)? "Update Vendor | " +process.env.COPYRIGHT_NAME : "Create Vendor | " +process.env.COPYRIGHT_NAME
    }
  },
  
  mixins:[commonMixins],
  data: () => ({

        vendorId:"",
        canAddCity:false,
        permissions: [],
        cantAccessPage: "",
        name: "",
        phone_number: "",
        vendor_code: "",
        website: "",
        address_1: "",
        address_2: "",
        cityArr:[],
        stateArr:[],
        countryArr:[],
        paymenttypeArr:[],
        city_id: null,
        state: null,
        country: "",
        zip: "",
        contact_name: "",
        email: "",
        contact_phone_number: "",
        loading:false,
        miscEligible:1,
        payment_type_id:'',
        post_code_error:'',
        pay_to_exist:"0",
        assignee_number:'',
        total_invoice_amount:'',
        eligibleTaxTypeArr:[],
        notEligibleTaxTypeArr:[],
        eligibleVendorTaxType:null,
        notEligibleVendorTaxType:null,
        FEIN:"",
        fax:"",
        feinrrors: "",
        payExistError:"",
        assigneeError:'',
        vendor_type:"",
        last_invoice_date:"",
        vendor_tax_id_number:"",
        vendorTypeError:"",
        vendorTaxIDNoError:"",
        faxError:"",
        vendor_create_date:"",
        pay_to_vendor_number:"",
        pay_to_vendor:"",
        total_pay_amount:"",
        vendor_count: [],
        totalPayAmountError:"",
        taxerrors: '',
        nameerrors: '',
        codeerrors: '',
        payToVendorNoError:'',
        payToVendorError:'',
        phone_number_error_msg: "",
        contact_phone_number_error_msg: "",
        vendorCreateError:"",
        paymentTypeError:"",
        totalInvoiceAmountError:"",
        lastInvoiceDateError:"",
        email_error_msg: "",
        optionsDate: {
          format: 'MM/DD/YYYY',
          useCurrent: false,
        },
        codeField1:"",
        codeField2:"",
        codeField3:"",
        classification:[],
        // classificationArr:[{text:"Fuel",value:"fuel"},{text:"Service",value:"service"},
        //     {text:"Parts",value:"parts"}],
        termerrors:'',
        term_id:'',
        termArr:[],
        po_required:false,
        DBAname:"",
        oneTimeVendor:false,
        financierVendor:false,
        requiredRemittance:false,
        ntlsvendor:false,
        isRequired:"require",
        contactEmail:"",
        contact_email_error_msg:"",
        addressErrorMsg:"",
        seperate_cheque:false,
        monthly_payable:false,
        isUpdate:false,
        filesArr:[],
        existFilesArr:[],
        fileerror_msg:"",
        city_error_msg: '',
        payment_type:null,
        paymentArr: [
        {
            value: "ACH",
            text: "ACH"
        },
        {
            value: "CHECK",
            text: "CHECK"
        },
        {
            value: "COMCHECK",
            text: "COMCHECK"
        },
        {
            value: "CREDIT CARD",
            text: "CREDIT CARD"
        },
    ],
    financier_gl:null,
    financier_gl_error_msg:"",
    liabilityAccountsArr:[],
    disableFinancierGL:false,
    assignee:null,
    vendorArr:[],
    vendor_duplicate: false,
    vendor_code_error_msg:"",
    requiredAttachment:0,
    statusArr: ['active','inactive'],
    vendorStatus: 'active',
  }),
    watch: {

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_vendor') {

                        self.cantAccessPage = true;

                    }
                }
            }

        },
        //update error message
        eligibleVendorTaxType: function (newVal) {
            $('#federalTaxTypeError').text('');
            self.taxerrors = "";
            self.notEligibleVendorTaxType = null;
        },

        oneTimeVendor: function (isCheck) {
            if ( isCheck || this.financierVendor ) {
                this.isRequired = "";
            } else {
                this.isRequired = "require";
            }
        },
        financierVendor: function (isCheck) {
            if ( isCheck || this.oneTimeVendor ) {
                this.isRequired = "";
            } else {
                this.isRequired = "require";
            }


            var path = window.location.pathname;
            var segments = path.split("/");


            if(this.financierVendor) {
              if (!segments[3]) {
                this.getFinancierCode();
              }

            } else {
              this.disableFinancierGL = false;
              this.financier_gl = null;
              this.newVendorCode();
            }
        },


        notEligibleVendorTaxType: function (newVal) {
            var self = this;
            if ( newVal.text == "Government Agency" || newVal.text == "Employee" ){
                $('#fein').prop('disabled',true);
                $("#feinError").text("");
                self.FEIN = "";
                self.feinrrors = "";
            }
            else{
                $('#fein').prop('disabled',false);
            }
            $('#federalTaxTypeError').text('');
            self.taxerrors = "";
            self.eligibleVendorTaxType = null;
        },

        //if state value update after then change the city value also update that in thie module.
        state: function(state) {

            var self = this;

            if(self.state == null){
                self.city_id = null;
                self.cityArr = [];
            }
        }

    },

  created: function() {

  },
  mounted: function() {

        var self = this;

        var path = window.location.pathname;
        var segments = path.split("/");

        self.getPermissions();
        //load vendor tax types
        self.getFederalTaxTypes();
        self.getPaymentTypes();
        self.loadTermData();
        if (!segments[3]) {
           self.newVendorCode();
        }

        //when going to edit page its not display header and button
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3]) {
                this.vendorId= segments[3];
                self.loadVendor();
                self.isUpdate = true;
            }

  },
    methods: {
        popCityName(cid){
          console.log("check"+cid);
          // this.city_id =cid;
          this.city_id = {value: cid.id, text: cid.name};
        },
        getFinancierCode() {

            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/financier/code",
                type: "POST",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    if (data.status == "success") {
                        var newCode = data.content;
                        if (newCode != "" && newCode != null) {
                            var codeArr = newCode.split("-");
                            if(codeArr.length > 0){
                                self.codeField1 = codeArr[0];
                                self.codeField2 = codeArr[1];
                                self.codeField3 = codeArr[2];
                            }else{
                                self.codeField1 = "001";
                                self.codeField2 = "50000000";
                                self.codeField3 = "000";
                            }
                        }else{
                            self.codeField1 = "001";
                            self.codeField2 = "50000000";
                            self.codeField3 = "000";
                        }

                    }else{
                        self.codeField1 = "001";
                        self.codeField2 = "50000000";
                        self.codeField3 = "000";
                    }


                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'new-vendor-code');
                }
            });
        },

        loadTermData() {

            var self = this;
            $.ajax({
                url: process.env.ROOT_API + "/customer/search",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: 'json',
                success: function (data) {

                    if (data.status == "success") {

                        self.termArr = data.TermData;

                    }

                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR,true,'load-term-data');
                }
            });
        },
        //load federal taxes
        getFederalTaxTypes:function () {

            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/get-vendor-data",
                type: "get",
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    if (data.status == "success") {
                        self.eligibleTaxTypeArr = data.content.eligible;
                        self.notEligibleTaxTypeArr = data.content.notEligible;

                    }

                },

                error: function (jqXHR, exception) {

                    //self.CheckBtn = 'Check';
                    self.generateStatusCodeMessage(jqXHR,true,'load-federal-tax-type');
                }
            });

        },
        getPaymentTypes:function () {

            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/get_payment_types",
                type: "get",
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    if (data.status == "success") {
                        self.paymenttypeArr = data.content;

                    }

                },

                error: function (jqXHR, exception) {

                    //self.CheckBtn = 'Check';
                    self.generateStatusCodeMessage(jqXHR,true,'get-payment-types');
                }
            });

        },

        BackVendorList() {
        var self = this;
        self.$router.push("/vendor/list");
        },

        // onSearchCountry(search, loading) {
        //     if (search.length > 2) {
        //         loading(true);
        //         this.searchField(loading, search, 'country');
        //     }
        // },

        onSearchState(search, loading) {
            if (search.length > 2) {
                loading(true);
                this.searchField(loading, search, 'state');
            }
        },
        onSearchAssignee(search, loading) {
            if (search.length > 2) {
                loading(true);
                this.searchField(loading, search, 'assignee');
            }
        },

        onSearchCity(search, loading) {

            if (search.length > 2) {

                var stateId = this.state.value;
                if ( stateId == "" ) {
                    alert("please select state first");
                    return;
                }

                loading(true);
                this.searchField(loading, search, 'city');
            }
        },

        CreateVendor(flag) {

            var self = this;
            var error = false;

            self.contact_phone_number_error_msg = "";
            self.phone_number_error_msg = "";
            self.email_error_msg = "";
            self.nameerrors = "";
            self.taxerrors = "";
            self.feinrrors = "";
            self.payToVendorNoError = '';
            self.payToVendorError = '';
            self.vendorCreateError = "";
            self.paymentTypeError = "";
            self.totalInvoiceAmountError = "";
            self.lastInvoiceDateError = "";
            self.payExistError = "";
            self.totalPayAmountError = "";
            self.assigneeError = "";
            self.vendorTypeError = "";
            self.vendorTaxIDNoError = "";
            self.faxError="";
            self.termerrors = "";
            self.post_code_error="";
            self.contact_email_error_msg = "";
            self.addressErrorMsg = "";
            self.fileerror_msg = "";
            self.financier_gl_error_msg = "";
            self.vendor_code_error_msg = "";

            console.log("length check");
            if (self.zip != null) {

                if(self.zip.length > 5){
                    self.post_code_error = "Postal Code should not be more than 5 digits.";
                    error = true;
                }
            }

            if ( (!self.codeField1 && self.codeField1 == "" ) || (!self.codeField2 && self.codeField2 == "" ) || (!self.codeField3 && self.codeField3 == "" )  ) {
                self.vendor_code_error_msg = "Please enter code properly.";
                error = true;
            }

                //   if(self.website.includes("http://") == false && self.website != ""){
                //       $("#websiteError").text("Please enter Web page URL starting with http://");
                //       result = false;
                //   }

                /*
                if ( self.notEligibleVendorTaxType == "" && self.eligibleVendorTaxType == "" ) {

                    $("#federalTaxTypeError").text("Please select federal tax type");
                    result = false;

                } else {

                    if ( self.notEligibleVendorTaxType.text == "Government Agency" || self.notEligibleVendorTaxType.text == "Employee" ) {
                        $("#feinError").text("");
                    } else {

                        if ( self.FEIN == "") {
                            $("#feinError").text("Please enter FEIN Number");
                            result = false;
                        }
                    }
                }*/

            if (self.name == null || self.name == "") {
                self.nameerrors = "Please enter name.";
                error = true;
            }

            //if vendor is one time then no need of tax and FEIN
            if ( self.oneTimeVendor == 0 && self.financierVendor == 0) {

                if(self.miscEligible == 1){

                    if (self.eligibleVendorTaxType == null || self.eligibleVendorTaxType.value == "" || self.eligibleVendorTaxType == "")  {
                        self.taxerrors = "Please select federal tax type";
                        error = true;

                    } else{
                        self.taxerrors = "";
                        /*if ( self.FEIN == "" || !self.FEIN || self.FEIN == null) {
                            // $("#feinError").text("Please enter FEIN Number");
                            self.feinrrors = "Please enter FEIN Number";
                            error = true;
                        }*/
                    }

                } else{

                    if ( self.notEligibleVendorTaxType == null || self.notEligibleVendorTaxType.value == "" || self.notEligibleVendorTaxType == "" ) {
                        self.taxerrors = "Please select federal tax type";
                        error = true;
                    } else {

                        self.taxerrors = "";
                        //if ( self.notEligibleVendorTaxType.text == "Government Agency" || self.notEligibleVendorTaxType.text == "Employee" ) {

                        //} else {

                            /*if ( self.FEIN == "" || !self.FEIN || self.FEIN == null) {
                                // $("#feinError").text("Please enter FEIN Number");
                                self.feinrrors = "Please enter FEIN number";
                                error = true;
                            }*/
                        //}
                    }

                }
            }


            var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

            if(self.phone_number && self.phone_number != "___-___-____" && !self.phone_number.match(phoneRE)){
                self.phone_number_error_msg = "Phone number is not in proper format please update";
                error = true;
            }

            if(self.contact_phone_number && self.contact_phone_number != "___-___-____" && !self.contact_phone_number.match(phoneRE)){
                self.contact_phone_number_error_msg = "Contact phone number is not in proper format please update";
                error = true;
            }

            if (!self.term_id || self.term_id == null || self.term_id == "") {
                self.termerrors = "Please select term.";
                error = true;
            }

            if (!self.payment_type || self.payment_type == null || self.payment_type == "") {
                self.paymentTypeError = "Payment Type Required.";
                error = true;
            }
            /*if(self.phone_number && !String(self.phone_number).match(/^[0-9]*$/)){
                self.phone_number_error_msg = "Phone Number Must Be Numeric";
                error = true;
            }

            if(self.phone_number && String(self.phone_number).match(/^[0-9]*$/) && self.phone_number.length < 10){
                self.phone_number_error_msg = "Phone Number Must Be Of Minimum 10 Digits";
                error = true;
            }

            if(self.phone_number && String(self.phone_number).match(/^[0-9]*$/) && self.phone_number.length > 12){
                self.phone_number_error_msg = "Phone Number Must Be Of Maximum 12 Digits";
                error = true;
            }*/

            //as suggest by rachel to make email optional
            // if (!self.email || self.email == '') {
            //     self.email_error_msg = "Please enter email.";
            //     error = true;
            // }

            if (self.email && !self.validEmail(self.email)) {
                self.email_error_msg = "Enter valid email.";
                error = true;
            }

            if (self.contactEmail && !self.validEmail(self.contactEmail)) {
                self.contact_email_error_msg = "Enter valid contact email.";
                error = true;
            }

            if ( !self.address_1 && self.address_1 == "" ) {
                self.addressErrorMsg = "Please enter address.";
                error = true;
            }


            /*if(self.contact_phone_number && !String(self.contact_phone_number).match(/^[0-9]*$/)){
                self.contact_phone_number_error_msg = "Contact Phone Number Must Be Numeric";
                error = true;
            }

            if(self.contact_phone_number && String(self.contact_phone_number).match(/^[0-9]*$/) && self.contact_phone_number.length < 10){
                self.contact_phone_number_error_msg = "Contact Phone Number Must Be Of Minimum 10 Digits";
                error = true;
            }

            if(self.contact_phone_number && String(self.contact_phone_number).match(/^[0-9]*$/) && self.contact_phone_number.length > 12){
                self.contact_phone_number_error_msg = "Contact Phone Number Must Be Of Maximum 12 Digits";
                error = true;
            }*/
            if(self.fax && self.fax != "___-___-____" && !self.fax.match(phoneRE)){
                self.faxError = "Fax No must be in proper format";
                error = true;
            }

            if ( self.filesArr.length > 0 ) {
                for (var i = 0; i < self.filesArr.length; i++) {

                    let file = self.filesArr[i];
                    if(file.type == "image/jpeg" || file.type == "image/png" || file.type == 'application/pdf' || self.checkFileExtension(file.name) == 'doc' || self.checkFileExtension(file.name) == 'docx') {

                    } else {
                        self.fileerror_msg = 'Only Images, Doc or PDF Files Are Allowed (.png / .jpeg / .pdf / .doc / .docx)';
                        error = true;
                    }
                }
            }
            //if vendor is financier then gl account required
            if (self.financierVendor) {
                if ( self.financier_gl == null || self.financier_gl == "" ) {
                    self.financier_gl_error_msg = "Financier GL Account Required.";
                    error = true;
                }
            }
            //self.vendorDuplicateCheckIn();
            if(self.vendor_duplicate == true){
              error = true;
            }
            console.log(error);
            if (!error) {

                $("#federalTaxTypeError").text("");
                $("#feinError").text("");

                var path = window.location.pathname;
                var segments = path.split("/");

                var fields = new FormData();
                if (segments[3])
                {
                    $("#createVendorBtn").val("Updating ...");
                    $("#createVendorBtn").prop("disabled", true);
                    $("#cancelVendorBtn").prop("disabled",true);
                    fields.append("id", segments[3]);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinueVendorBtn").val("Saving ...");
                        $("#createVendorBtn").prop("disabled", true);
                        $("#createAndContinueVendorBtn").prop("disabled", true);
                        $("#cancelVendorBtn").prop("disabled",true);

                    }else{

                        $("#createVendorBtn").val("Saving ...");
                        $("#createVendorBtn").prop("disabled", true);
                        $("#createAndContinueVendorBtn").prop("disabled", true);
                        $("#cancelVendorBtn").prop("disabled",true);
                    }
                    fields.append("id", "");

                }


                fields.append("vendor_code",self.getFormattedVendorCode());
                fields.append("v_code",self.codeField2);

                if ( self.oneTimeVendor == true ) {
                    fields.append("one_time_vendor",1);
                } else {
                    fields.append("one_time_vendor",0);
                }
                if ( self.requiredAttachment == true ) {
                    fields.append("required_attachment",1);
                } else {
                    fields.append("required_attachment",0);
                }
                if ( self.requiredRemittance == true ) {
                    fields.append("required_remittance",1);
                } else {
                    fields.append("required_remittance",0);
                }
                if ( self.financierVendor == true ) {
                    fields.append("financier_vendor",1);
                    fields.append("financier_gl",self.financier_gl.value);
                } else {
                    fields.append("financier_vendor",0);
                    fields.append("financier_gl","");
                }
                if ( self.ntlsvendor == true ) {
                    fields.append("is_ntls_vendor",1);
                } else {
                    fields.append("is_ntls_vendor",0);
                }

                if ( self.country != "" && self.country != null) {
                    fields.append("country_id",self.country.value);
                } else {
                    fields.append("country_id","");
                }

                if ( self.state == null ) {
                    fields.append("state_id","");
                } else {
                    fields.append("state_id",self.state.value);
                }

                if ( self.city_id == null ) {
                    fields.append("city_id","");
                } else {
                    fields.append("city_id",self.city_id.value);
                }

                if ( self.assignee == null ) {
                    fields.append("assignee_id",null);
                } else {
                    fields.append("assignee_id",self.assignee.value);
                }

                if ( self.term_id == null || self.term_id == '' ) {
                    fields.append("term_id","");
                } else {
                    fields.append("term_id",self.term_id.value);
                }

                if ( self.miscEligible == 1 ) {
                    if ( self.eligibleVendorTaxType != null && self.eligibleVendorTaxType != "" ) {
                        fields.append("vendor_tax_type_id",self.eligibleVendorTaxType.value);
                    } else {
                        fields.append("vendor_tax_type_id","");
                    }

                } else {

                    if ( self.notEligibleVendorTaxType != null && self.notEligibleVendorTaxType != "" ) {

                        fields.append("vendor_tax_type_id",self.notEligibleVendorTaxType.value);
                    } else {
                        fields.append("vendor_tax_type_id","");
                    }

                }

                // if ( self.payment_type_id == null ) {
                //     fields.append("payment_type_id","");
                // } else {
                //     fields.append("payment_type_id",self.payment_type_id.value);
                // }
                fields.append("classification",JSON.stringify(self.classification));
                if(self.po_required == true){
                    fields.append("po_required",1);
                }else{
                    fields.append("po_required",0);
                }

                if (self.phone_number != "___-___-____" && self.phone_number !== null) {
                    fields.append("phone_number",self.phone_number);
                }else{
                    fields.append("phone_number","");
                }
                if (self.contact_phone_number != "___-___-____" && self.contact_phone_number !== null) {
                    fields.append("contact_phone_number",self.contact_phone_number);
                }else{
                    fields.append("contact_phone_number","");
                }

                if (self.fax != "___-___-____" && self.fax !== null) {
                    fields.append("fax",self.fax);
                }else{
                    fields.append("fax","");
                }
                if(self.seperate_cheque == true){
                    fields.append("seperate_cheque",1);
                }else{
                    fields.append("seperate_cheque",0);
                }
                if(self.monthly_payable == true){
                    fields.append("monthly_payable",1);
                }else{
                    fields.append("monthly_payable",0);
                }


                for (var i = 0; i < self.filesArr.length; i++) {
                    let file = self.filesArr[i];
                    fields.append('files', file);
                }


                if(self.FEIN !== null){
                    fields.append("fein",self.FEIN);
                } else {
                fields.append("fein", "");
                }
                if(self.email !== null){
                    fields.append("email",self.email);
                } else {
                fields.append("email","");
                }
                if(self.DBAname !== null){
                    fields.append("dba_name",self.DBAname);
                } else {
                fields.append("dba_name", "");
                }

                if(self.website !== null){
                    fields.append("website",self.website);
                } else {
                fields.append("website","");
                }
                if(self.address_2 !== null){
                    fields.append("address_2",self.address_2);
                } else {
                fields.append("address_2", "");
                }
                if(self.contact_name !== null){
                    fields.append("contact_name",self.contact_name);
                } else {
                fields.append("contact_name", "");
                }
                if(self.contact_phone_number !== null){
                    fields.append("contact_phone_number",self.contact_phone_number);
                } else {
                fields.append("contact_phone_number", "");
                }

                if(self.contactEmail !== null){
                    fields.append("contact_email",self.contactEmail);
                } else {
                fields.append("contact_email", "");
                }
                if(self.vendor_type !== null){
                    fields.append("VendorType",self.vendor_type);
                } else {
                fields.append("VendorType", "");
                }
                if(self.vendor_tax_id_number !== null){
                    fields.append("VendorTaxIDNumber",self.vendor_tax_id_number);
                } else {
                fields.append("VendorTaxIDNumber", "");
                }
                if(self.vendor_create_date !== null){
                    fields.append("vendor_create_date",self.vendor_create_date);
                } else {
                fields.append("vendor_create_date", "");
                }
                fields.append("name",self.name);
                fields.append("address_1",self.address_1);
                fields.append("zip",self.zip);
                fields.append("federal_tax_eligible",self.miscEligible);
                if(self.payment_type != null) {
                fields.append("payment_type", self.payment_type.value);
                } else {
                fields.append("payment_type", "");
                }
                fields.append('status',self.vendorStatus);
                console.log(fields);

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/vendor/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (segments[3])
                        {
                            $("#createVendorBtn").val("Update");
                            $("#createVendorBtn").prop("disabled", false);
                            $("#cancelVendorBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#createAndContinueVendorBtn").val("Save and Continue");
                                $("#createVendorBtn").prop("disabled", false);
                                $("#createAndContinueVendorBtn").prop("disabled", false);
                                $("#cancelVendorBtn").prop("disabled",false);

                            }else{

                                $("#createVendorBtn").val("Save");
                                $("#createVendorBtn").prop("disabled", false);
                                $("#createAndContinueVendorBtn").prop("disabled", false);
                                $("#cancelVendorBtn").prop("disabled",false);

                            }
                        }
                        if (data.status == "success") {
                            if (flag == "Save and Continue") {
                                self.getFederalTaxTypes();

                                self.getFederalTaxTypes();
                                self.name = "";
                                self.phone_number = "";
                                self.website = "";
                                self.address_1 = "";
                                self.address_2 = "";
                                // self.cityArr = [];
                                // self.stateArr = [];
                                // self.countryArr = [];
                                self.zip = "";
                                self.contact_name = "";
                                self.email = "";
                                self.contact_phone_number = "";
                                self.oneTimeVendor = false;
                                self.financierVendor = false;
                                self.requiredRemittance = false;
                                self.contactEmail = "";
                                self.city_id =  null;
                                self.state = null;
                                self.country = "";
                                self.eligibleVendorTaxType = null;
                                self.notEligibleVendorTaxType = null;
                                self.FEIN = "";
                                //self.payment_type_id='';
                                self.pay_to_exist="1";
                                self.assignee_number='';
                                self.total_invoice_amount='';
                                self.vendor_type="";
                                self.last_invoice_date="";
                                self.vendor_tax_id_number="";
                                self.vendor_create_date="";
                                self.pay_to_vendor_number="";
                                self.pay_to_vendor="";
                                self.total_pay_amount="";
                                self.fax="";
                                self.classification = [];
                                $("#poRequired").prop("checked",false);
                                self.po_required = false;
                                $("#seperate_cheque").prop("checked",false);
                                self.seperate_cheque = false;
                                $("#monthly_payable").prop("checked",false);
                                self.monthly_payable = false;
                                self.payment_type = null;
                                self.financier_gl = null;
                                self.vendor_code_error_msg = "";
                                self.vendor_duplicate = false;

                                $('#fein').prop('disabled',false);

                            }else{
                                self.$router.push("/vendor/list");
                            }

                        } else {
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (segments[3])
                        {
                            $("#createVendorBtn").val("Update");
                            $("#createVendorBtn").prop("disabled", false);
                            $("#cancelVendorBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#createAndContinueVendorBtn").val("Save and Continue");
                                $("#createVendorBtn").prop("disabled", false);
                                $("#createAndContinueVendorBtn").prop("disabled", false);
                                $("#cancelVendorBtn").prop("disabled",false);

                            }else{

                                $("#createVendorBtn").val("Save");
                                $("#createVendorBtn").prop("disabled", false);
                                $("#createAndContinueVendorBtn").prop("disabled", false);
                                $("#cancelVendorBtn").prop("disabled",false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,false,'vendor-create');
                    }
                });
            }else{
                    self.errorValidationFocus();
            }
        //   });
        },
        vendorDuplicateCheckIn() {
          var self = this;
          var error = false;
          var vendorCode =  '';
          if(self.codeField1 != "" && self.codeField2 != "" && self.codeField3 != ""){
                vendorCode = self.codeField1+ "-" + self.codeField2 + "-" + self.codeField3;
          }

          $.ajax({
                url: process.env.ROOT_API + "/vendor-code/duplicate-check",
                type: "POST",
                headers: this.ajxHeaders,
                data: {vendor : vendorCode},
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    if (data.status == "success") {
                        if(data.code == 200){
                          self.vendor_code_error_msg = "This Vendor Code already exist!!";
                          error = true;
                          self.vendor_duplicate = true;
                        }else if(data.code == 201) {
                          self.vendor_code_error_msg = "";
                          error = false;
                          self.vendor_duplicate = false;

                        }

                    }


                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-code')
                }
            });
        },

        loadVendor() {

            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/vendor/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    // console.log(data);
                    self.loading = false;
                    if (data.status == "success") {

                        if ( data.content.one_time_vendor == 1 ) {
                            $("#one_time_vendor").prop("checked",true);
                            self.oneTimeVendor = true;
                        } else {
                            $("#one_time_vendor").prop("checked",false);
                            self.oneTimeVendor = false;
                        }
                        if ( data.content.is_ntls_vendor == 1 ) {
                            $("#ntlsvendor").prop("checked",true);
                            self.ntlsvendor = true;
                        } else {
                            $("#ntlsvendor").prop("checked",false);
                            self.ntlsvendor = false;
                        }

                        if ( data.content.financier_vendor == 1 ) {
                            $("#financierVendor").prop("checked",true);
                            self.financierVendor = true;
                        } else {
                            $("#financierVendor").prop("checked",false);
                            self.financierVendor = false;
                        }
                        if ( data.content.required_attachment == 1 ) {
                            $("#required_attachment").prop("checked",true);
                            self.requiredAttachment = true;
                        } else {
                            $("#required_attachment").prop("checked",false);
                            self.requiredAttachment = false;
                        }
                        if ( data.content.remittance == 1 ) {
                            $("#required_remittance").prop("checked",true);
                            self.requiredRemittance = true;
                        } else {
                            $("#required_remittance").prop("checked",false);
                            self.requiredRemittance = false;
                        }
                        if (self.financierVendor) {
                            if (data.content.financier_gl_account != undefined && data.content.financier_gl_account != null){
                                self.financier_gl = {value: data.content.financier_gl_account, text: self.ucString(data.content.glCode + " | " + data.content.glDesc)};
                            }else{
                                self.financier_gl = null;
                            }
                        }else{
                            self.financier_gl = null;
                        }

                        self.name = data.content.name;
                        self.phone_number = data.content.phone;
                        self.website = data.content.website;
                        self.address_1 = data.content.address_1;
                        self.address_2 = data.content.address_2;
                        self.DBAname = data.content.dba_name;
                        self.country = {value: data.content.country_id, text: data.content.countryName};

                        if(data.content.state_id == null) {
                            self.state = null;
                        } else{
                            self.state = {value: data.content.state_id, text: self.titleCase(data.content.stateName)};
                        }

                        if(data.content.city_id == null) {
                            self.city_id = null;
                        } else{
                            self.city_id = {value: data.content.city_id, text: self.titleCase(data.content.cityName)};
                        }

                        if(data.content.assignee_id == null) {
                            self.assignee = null;
                        } else{
                            self.assignee = {value: data.content.assignee_id, text: self.titleCase(data.content.assignee)};
                        }


                        self.zip = data.content.zip;
                        self.contact_name = data.content.contact_name;
                        self.contact_phone_number = data.content.contact_phone;
                        self.email = data.content.email;
                        self.contactEmail = data.content.contact_email;
                        self.miscEligible = data.content.federal_tax_eligible;
                        self.FEIN = data.content.fein;
                        if ( data.content.federal_tax_eligible == 1 ) {
                            self.eligibleVendorTaxType = {value:data.content.vendor_tax_type_id,text:data.content.vendor_tax_name};
                        } else {
                            self.notEligibleVendorTaxType = {value:data.content.vendor_tax_type_id,text:data.content.vendor_tax_name};
                        }

                        self.vendor_code = self.displayFormattedVendorCode(data.content.vendor_code);

                        // if(data.content.payment_type_id == null) {
                        //     self.payment_type_id = null;
                        // }else{
                        //     self.payment_type_id =  {value: data.content.payment_option_code, text: data.content.payment_option_name};
                        // }

                        if(data.content.termId == null) {
                            self.term_id = null;
                        }else{
                            self.term_id =  {value: data.content.termId, text: self.titleCase(data.content.termName)+' ('+data.content.termCode+')'};
                        }


                        self.pay_to_exist=data.content.pay_to_exist;
                        self.assignee_number=data.content.assignee_number;
                        self.total_invoice_amount=data.content.total_invoice_amount;
                        self.vendor_type=data.content.vendor_type;
                        self.vendor_tax_id_number=data.content.vendor_tax_id_number;
                        if(data.content.vendor_create_date != "" || data.content.vendor_create_date != null){
                            self.vendor_create_date = moment(data.content.vendor_create_date).format('MM/DD/YYYY');
                        }else{
                            self.vendor_create_date = "";
                        }
                        if(data.content.last_invoice_date != "" || data.content.last_invoice_date != null){
                            self.last_invoice_date = moment(data.content.last_invoice_date).format('MM/DD/YYYY');
                        }else{
                            self.last_invoice_date = "";
                        }
                         if(data.content.payment_type != "" && data.content.payment_type != null) {
                            self.payment_type = {value: data.content.payment_type, text: data.content.payment_type};
                        }else{
                            self.payment_type = null;
                        }


                        self.pay_to_vendor_number=data.content.pay_to_vendor_number;
                        self.pay_to_vendor=data.content.pay_to_vendor;
                        self.total_pay_amount=data.content.total_pay_amount;
                        self.fax=data.content.fax;
                        self.classification = data.content.classification;
                        if(data.content.po_required == 1){
                            $("#poRequired").prop("checked",true);
                            self.po_required = true;
                        }else{
                            $("#poRequired").prop("checked",false);
                            self.po_required = false;
                        }
                        if(data.content.seperate_cheque == 1){
                            $("#seperate_cheque").prop("checked",true);
                            self.seperate_cheque = true;
                        }else{
                            $("#seperate_cheque").prop("checked",false);
                            self.seperate_cheque = false;
                        }
                        if(data.content.monthly_payable == 1){
                            $("#monthly_payable").prop("checked",true);
                            self.monthly_payable = true;
                        }else{
                            $("#monthly_payable").prop("checked",false);
                            self.monthly_payable = false;
                        }
                        self.existFilesArr = data.content.docs;
                        if (data.content.disable_financier_gl != undefined && data.content.disable_financier_gl != null) {
                            if (data.content.disable_financier_gl == 1) {
                                self.disableFinancierGL = true;
                            }else{
                                self.disableFinancierGL = false;
                            }
                        }else{
                            self.disableFinancierGL = false;
                        }
                        console.log('Vendor Status: ',data.content.status);
                        self.vendorStatus = data.content.status;

                        // alert("Fuel : " + self.checkbox_value_fuel + ", Service : " + self.checkbox_value_service + ", Parts : " + self.checkbox_value_parts);
                        // alert("Fuel : " + self.checked_fuel + ", Service : " + self.checked_service + ", Parts : " + self.checked_parts);
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'vendor-data');
                }
            });
        },
        validEmail: function(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        newVendorCode(){
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/vendor/code",
                type: "POST",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    if (data.status == "success") {
                        var newCode = data.content;
                        if (newCode != "" && newCode != null) {
                            var codeArr = newCode.split("-");
                            if(codeArr.length > 0){
                                self.codeField1 = codeArr[0];
                                self.codeField2 = codeArr[1];
                                self.codeField3 = codeArr[2];
                            }else{
                                self.codeField1 = "001";
                                self.codeField2 = "20000000";
                                self.codeField3 = "000";
                            }
                        }else{
                            self.codeField1 = "001";
                            self.codeField2 = "20000000";
                            self.codeField3 = "000";
                        }

                    }else{
                        self.codeField1 = "001";
                        self.codeField2 = "20000000";
                        self.codeField3 = "000";
                    }


                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'new-vendor-code');
                }
            });
        },
        getFormattedVendorCode(){
            var self = this;
            var code = "";
            if(self.codeField1 != "" && self.codeField2 != "" && self.codeField3 != ""){
                code = self.codeField1+ "-" + self.codeField2 + "-" + self.codeField3;
            }else{
                code = "001-20000000-000"
            }
            return code;
        },
        displayFormattedVendorCode(code){
            var self = this;
            var displayCode = code.split("-");
            if(displayCode.length > 0){
                self.codeField1 = displayCode[0];
                self.codeField2 = displayCode[1];
                self.codeField3 = displayCode[2];
            }
        },
        titleCase(str) {
                if (str == null) {
                    return;
                } else {
                    var value = str.toString()
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
        },
        poRequired(e) {
            var self = this;

            if(e.target.checked) {
                self.po_required = true;
            }else{
                self.po_required = false;
            }

        },
        seperateCheque(e) {
            var self = this;

            if(e.target.checked) {
                self.seperate_cheque = true;
            }else{
                self.seperate_cheque = false;
            }

        },
        monthlyPayable(e) {
            var self = this;

            if(e.target.checked) {
                self.monthly_payable = true;
            }else{
                self.monthly_payable = false;
            }

        },
        handleFilesUpload() {
            var self = this;
            if (!self.isUpdate) {
                    self.filesArr = [];
                    self.fileerroor_msg = "";

                    let uploadedFiles = "";
                    uploadedFiles = self.$refs.files.files;
                    for (var i = 0; i < uploadedFiles.length; i++) {

                        this.filesArr.push(uploadedFiles[i]);

                    }
                    this.$refs.files.value = '';
                }else{
                    if ( self.existFilesArr.length > 0 ) {

                        if (confirm('Do you want to upload file? ')) {
                            self.filesArr = [];
                            self.fileerroor_msg = "";

                            let uploadedFiles = "";
                            uploadedFiles = self.$refs.files.files;
                            for (var i = 0; i < uploadedFiles.length; i++) {

                                this.filesArr.push(uploadedFiles[i]);

                            }
                            this.$refs.files.value = '';
                            self.isUpdate = false;
                        }

                    }else{
                        self.isUpdate = false;
                        self.filesArr = [];
                        self.fileerroor_msg = "";

                        let uploadedFiles = "";
                        uploadedFiles = self.$refs.files.files;
                        for (var i = 0; i < uploadedFiles.length; i++) {

                            this.filesArr.push(uploadedFiles[i]);

                        }
                        this.$refs.files.value = '';
                    }
                }
        },
        deleteDoc: function(id,key) {
                var self = this;

                if (confirm('Are you sure that you want to remove file? ')) {
                    this.filesArr.splice(key,1)
                    self.$refs.files.value = '';
                    self.fileerror_msg = "";
                }
        },
        checkFileExtension(fileName) {
                return fileName.split('.').pop();
        },
        deleteVendorFile(key,file) {
            var self = this;
            if (confirm('Are you sure that you want to remove file? ')) {

                    if(self.vendorId != '' && self.vendorId != undefined){

                        self.loading = true;

                        $.ajax({
                            url: process.env.ROOT_API + "/remove-vendor-file",
                            type: "POST",
                            crossDomain: true,
                            dataType: "json",
                            headers: this.ajxHeaders,
                            data: {
                                id:self.vendorId,
                                doc_path:file
                            },
                            success: function(data) {
                                self.loading = false;
                                if (data.status == "success") {

                                    self.loadVendor();
                                    self.$refs.files.value = '';
                                    self.existFilesArr = [];
                                }
                            },
                            error: function(jqXHR, exception) {
                                self.loading = false;
                                self.files.splice(key,1);
                                self.generateStatusCodeMessage(jqXHR,true,'vendor-doc-remove');
                            }
                        });

                    } else{

                        self.filesArr.splice(key,1);
                        self.$refs.files.value = '';

                    }
                }
        },
        onSearchFinancierGL(search, loading) {
            if (search.length > 2) {
                loading(true);
                this.searchField(loading, search, 'liability accounts');
            }
        },

    }
};
</script>



// WEBPACK FOOTER //
// src/components/VendorCreate.vue